import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User unfollowed a board',
  name: 'Unfollowed Boards',
  params: [
    {
      description: 'Location of user action',
      name: 'location',
      required: true,
      type: 'enum',
      values: ['notifications settings', 'board header'],
    },
    {
      description: 'Id of unfollowed board',
      name: 'boardId',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
